import { render, staticRenderFns } from "./EstoqueVisaoGeral.vue?vue&type=template&id=5defdfa1&"
import script from "./EstoqueVisaoGeral.vue?vue&type=script&lang=js&"
export * from "./EstoqueVisaoGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports